import * as React from 'react';
import NormalizeProgress from '../Normalizacion/NormalizeProgress';
import Layout from '../components/Utilities/Layout';
import NormalizeData from '../Normalizacion/NormalizeData';
import Link from '@mui/material/Link';
import SecurityTrimmer from '../components/Utilities/SecurityTrimmer';
import { Entity, PermissionLevel } from '../utilities/Permisos';

export default class Normalize extends React.Component<{}, {}> {
    public constructor(props: {}) {
        super(props);
    }

    public render(): React.ReactElement<{}> {
        return (
            <div>
                <SecurityTrimmer entity={Entity.Normalizaciones} permission={PermissionLevel.Crear} noAccessMessage='No tiene permisos para ver este contenido.'>
                    <Layout>
                        <NormalizeData/>
                    </Layout>
                </SecurityTrimmer>
            </div>
        )
    }
}